// packages/ui/src/store/draftId.ts
//
// A draft file is keyed by an opaque, filename-safe id derived from the doc id.
// We combine two hashes so collisions across the handful of open docs are
// negligible. The id is only `[0-9a-f]` after a leading `d`, so it is always a
// safe single path segment for the native session store.

function hashHex(s: string, seed: number): string {
  let h = seed >>> 0;
  for (let i = 0; i < s.length; i++) {
    h = (Math.imul(h, 31) + s.charCodeAt(i)) >>> 0;
  }
  return h.toString(16).padStart(8, '0');
}

export function draftIdFor(docId: string): string {
  return 'd' + hashHex(docId, 2166136261) + hashHex(docId, 5381);
}

/**
 * Live `docId -> draftId` map. The draft engine reads it so a restored untitled
 * buffer (which gets a brand-new runtime doc id) keeps writing to the SAME
 * draft file the manifest already references, via `assign()` at restore time.
 */
const map = new Map<string, string>();
export const draftRegistry = {
  idFor(docId: string): string {
    let id = map.get(docId);
    if (!id) {
      id = draftIdFor(docId);
      map.set(docId, id);
    }
    return id;
  },
  assign(docId: string, draftId: string): void {
    map.set(docId, draftId);
  },
  forget(docId: string): string | undefined {
    const id = map.get(docId);
    map.delete(docId);
    return id;
  },
  _resetForTest(): void {
    map.clear();
  },
};
